import { render, staticRenderFns } from "./LosSchimpfos.vue?vue&type=template&id=331766f8"
import script from "./LosSchimpfos.vue?vue&type=script&lang=js"
export * from "./LosSchimpfos.vue?vue&type=script&lang=js"
import style0 from "./LosSchimpfos.vue?vue&type=style&index=0&id=331766f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports